<h5 class="mt-auto small-caps">Notifications</h5>
<div class="list-group list-group-flush mb-5">
  @for (notificationSetting of notificationsProfile().notificationSettings; track notificationSetting; let i = $index) {
    <div class="list-group-item">
      <div class="w-100 d-flex">
        <span class="my-auto">{{ notificationSetting.bundleIdentifier }}</span>
        <button type="button"
                class="btn btn-outline-primary border-0 ms-auto"
                (click)="selectedItem = selectedItem === i ? null : i">
          <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
        </button>
      </div>
      <div class="collapse"
           [class.show]="selectedItem === i">
        <ml-mdm-notification-setting [title]="''"
                                     [notificationSetting]="notificationSetting"
                                     [mutate]="true"
                                     [allowToggle]="false"></ml-mdm-notification-setting>
        <button class="btn btn-outline-primary border-0 ms-auto d-block"
                (click)="remove(notificationSetting)">
          <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
        </button>
      </div>
    </div>
  }
  @if (!notificationsProfile()?.notificationSettings || notificationsProfile()?.notificationSettings?.length === 0) {
    <p>Add notification settings for an app by specifing them below.</p>
  }
</div>
<ml-mdm-notification-setting #newNotificationSettings
                             [(notificationSetting)]="newNotificationSetting"
                             [title]="'Add'"
                             [allowToggle]="false"
                             [mutate]="true"></ml-mdm-notification-setting>
<button type="button"
        class="btn btn-outline-primary mt-2"
        (click)="add()">Add</button>